<script>
  import MenuItem from "./MenuItem.svelte";
  import {RatesMenu} from "@util/constant"

</script>


<MenuItem Menu={RatesMenu} />
